import { channel } from 'diagnostics_channel';
import { VisitReportsFiltersModels } from './../../../models/visit-reports/visit-reports-filters.models';
import { OnlyTimePipe } from './../../../modules/shared/pipes/only-time.pipe';
import { RemoveHtmlTagsPipe } from './../../../modules/shared/pipes/remove-html-tags.pipe';
import { CurrencySymbolPipe } from 'src/app/modules/shared/pipes/currency-symbol.pipe';
import { PercentageSymbolPipe } from './../../../modules/shared/pipes/percentage-symbol.pipe';
import { RouteManagementService } from './../../../more/route-management/route-management.service';
import { ParseHelper } from './../../../modules/shared/parse.helper';
import { FormControlList } from './../../../modules/shared/constants/formcontrol-list.constants';
import { TimeConvertPipe } from './../../../modules/shared/pipes/timeConvert.pipe';
import { LocalDatePipe } from './../../../modules/shared/pipes/local-date.pipe';
import { AppMainComponent } from './../../../app.main.component';
import { SavedFilterData } from './../../../modules/shared/models/filter.model';
import { TimeZoneService } from './../../../modules/shared/services/timezone.service';
import { getSectionWiseFlatCols } from 'src/app/modules/shared/helpers/section-wise-cols.helper';
import { ColumnSettingsN, Fields } from './../../../modules/shared/models/column-settings.model';
import { AppMainService } from './../../../app-main.service';
import { AccountModuleId, LeadModuleId } from './../../../modules/shared/constants/modules.constant';
import { ActivatedRoute } from '@angular/router';
import { IReportsDataServiceLeftMenuExpantionModel, IReportsDataServiceTopMenuModel, ReportsDataServiceModelValues, ReportsTopMenuItemsValues } from './../../models/reports-data-service-model';
import { Component, OnDestroy, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { debounceTime, distinctUntilChanged, Subject, takeUntil } from 'rxjs';
import { DataService } from '../../dataService';
import { ReportsVisitsLabelName, ReportsVisitsNames, ReportsVisitsRoutes } from './../../models/reports-visits.enums';
import { VisitReportsService } from '../../services/visit-reports.service';
import { LazyLoadEvent, MenuItem, MessageService } from 'primeng/api';
import { GelAllDataRequestModel, GetAllDataGroupByRequest, ReportFilterInColumn, VisitDetailsRequest } from '../../models/reports-request.model';
import { FormControl } from '@angular/forms';
import { IDateFilterModel } from '../../models/reports-filter.models';
import { ReportsPrintPdfService } from '../../servies/reports-print-pdf.service';
import * as FileSaver from 'file-saver';
import * as moment from 'moment';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { latlngDistance } from 'src/app/modules/shared/helpers/distance-from-two-latlng.helpers';
import { PrintPdfModel } from '../../models/reports-print-pdf-model';
import { DatePipe } from '@angular/common';
import { ChartConfiguration, ChartData } from 'chart.js';
import { ReportsAllFiltersApplyModes, ReportsAllFiltersAppyModels, typeReportsAllFiltersApplyModes } from '../../models/reports-all-filter-appy.models';

@Component({
    selector: 'app-visit-reports',
    templateUrl: './visit-reports.component.html',
    styleUrls: ['./visit-reports.component.scss'],
    providers: [LocalDatePipe,DatePipe,TimeConvertPipe,PercentageSymbolPipe,CurrencySymbolPipe,RemoveHtmlTagsPipe,OnlyTimePipe]
})
export class VisitReportsComponent implements OnInit, OnDestroy, OnChanges {

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    @Input() dashboardView: string = "";
    @Input() displayFilterPopup: boolean = false;
    @Input() selectedWindow: string = "";
    @Input() reloadContent: boolean = false;
    @Input() selectedReportFilters: VisitReportsFiltersModels;
    @Output() onReloadContent: EventEmitter<any> = new EventEmitter<any>();
    @Output() onCloseFilterPopup: EventEmitter<any> = new EventEmitter<any>();
    @Output() onUpdateAllFilters: EventEmitter<ReportsAllFiltersAppyModels> = new EventEmitter<ReportsAllFiltersAppyModels>();

    tempFiltersValues: any;
    reportsFilterApplyMode: typeReportsAllFiltersApplyModes|"" = "";
    reportsAllFiltersApplyModes = ReportsAllFiltersApplyModes;
    filterPopupHeader: string = "Filters";

    organizationName: string = "";

    searchControl = new FormControl();
    searchValue: string = "";

    reportsVisitsNames = ReportsVisitsNames;
    reportName: string = "";
    accountsChannelList: any[] = [];
    accountsChannels: any[] = [];
    leadsChannelList: any[] = [];
    selectedChannel: any = null;
    selectedModuleId: number = null;
    selectedModuleName: string = "";

    selectedReportData: any = null;
    showFloatHeader: boolean = false;
    reflowTable: boolean = false;
    reportResults: any[] = [];
    exportResults: any[] = [];
    noDataFoundOrLoadingText: string = "Loading...";
    first: number = 0;
    pageNumber: number = 1;
    pageSize: number = 15;
    totalRecords: number = 0;
    gridState: any = {};
    tableShowMore: number[] = [15, 30, 50, 100];

    displayColumnSettings: boolean = false;
    columnSettingsN: Partial<ColumnSettingsN> = {};
    appliedFilterColName: string[] = [];
    disabledLabelNames: string[] = [];
    savedListCols: Fields[] = [];
    filterCols: Fields[] = [];
    enabledListCols: Fields[] = [];
    selectedColumn: string[] = [];
    saveFilterData: {
        groupByFieldId: number,
        filter: ReportFilterInColumn[],
    } = null;
    tempSaveFilterData: {
        groupByFieldId: number,
        filter: ReportFilterInColumn[],
    } = null;
    filteredColumns: string[] = [];
    filterInColumns: ReportFilterInColumn[] = [];
    sortByColumnName: string;
    isSortByDescending: boolean;

    selectedGroupByValue: any = null;
    selectedGroupBy: any = null;
    groupAllExpanded: boolean = false;

    menuItems: MenuItem[] = [
        {
            label: 'Settings',
            icon: 'pi pi-cog',
            command: () => this.openColumnSettings()
        }
    ];

    phoneFields: string[] = ['workphone','contactphonemobile', 'contactphonework', 'contactphonehome', 'contactphonecp1', 'contactphonecp2'];
    customDateRange: boolean = false;
    filterDataByTime: IDateFilterModel[] = [
        { label: 'Today', code: 'today' },
        { label: 'Yesterday', code: 'yesterday' },
        { label: 'This Month', code: 'this month' },
        { label: 'Last Month', code: 'last month' },
        { label: 'Last 7 days', code: 'last 7 days' },
        { label: 'Last 15 days', code: 'last 15 days' },
        { label: 'Last 30 days', code: 'last 30 days' },
        { label: 'Last 60 days', code: 'last 60 days' },
        { label: 'Last 90 days', code: 'last 90 days' },
        { label: 'Custom Date', code: 'custom' },
    ];
    selectedDateFilter: IDateFilterModel;
    dateFrom: Date = null;
    dateTo: Date = null;

    //Visit Details
    visitDetailsCols: Fields[] = [];
    displayVisitDetails: boolean = false;
    visitTotalRecords: number = 0;
    visitDetailsData: any[] = [];

    //charts
    public stackedBarByRep: any = {
        labels: [],
        datasets: [
            {
                type: 'bar',
                label: 'Geo Matched Visit',
                backgroundColor: '#66BB6A',
                data: []
            }
        ]
    };

    public barChartData: ChartData<'bar'> = {
        labels: [],
        datasets: [
            { data: [], label: 'Total Visits' },
            { data: [], label: 'Geo Matched Visits' },
            { data: [], label: 'Geo Not Matched Visits' },
        ],
    };

    public barChartOptions: ChartConfiguration<'bar'>['options'] = {
        // We use these empty structures as placeholders for dynamic theming.
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            x: {},
            y: {},
        },
        plugins: {
            legend: {
                display: true,
            }
        },
    };

    public stackedBarByTerri: any = {
        labels: [],
        datasets: [{
            type: 'bar',
            label: 'Geo Matched Visit',
            backgroundColor: '#66BB6A',
            data: []
        }, {
            type: 'bar',
            label: 'Geo Not Matched Visit',
            backgroundColor: '#ecb71c',
            data: []
        }]
    };

    territoryNamesList: any[] = [];
    selectedTerritory: any = null;
    currentSummaryResults: any[] = [];
    chartFilters: any[] = [
        {name: 'Total Visits', code: 'totalVisits'},
        {name: 'Geo Matched Visits', code: 'geoMatchedVisits'},
        {name: 'Geo Not Matched Visits', code: 'geoNotMatchedVisits'},
    ];
    selectedChartType: any = null;
    hideChart: boolean = false;
    hideChannelFilter: boolean = false;

    constructor(
        private app: AppMainComponent,
        private router: ActivatedRoute,
        private dataService: DataService,
        private datePipe: DatePipe,
        private localDatePipe: LocalDatePipe,
        private timeConvertPipe: TimeConvertPipe,
        private percentageSymbolPipe: PercentageSymbolPipe,
        private currencySymbolPipe: CurrencySymbolPipe,
        private removeHtmlTagsPipe: RemoveHtmlTagsPipe,
        private onlyTimePipe: OnlyTimePipe,
        private appMainService: AppMainService,
        private messageService: MessageService,
        private timeZoneService: TimeZoneService,
        private visitReportsService: VisitReportsService,
        private routeManagementService: RouteManagementService
    ) {
        this.organizationName = this.app.user.organizationName;
        this.dataService.getData<IReportsDataServiceTopMenuModel>().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(data => {
            if (data.actionType == ReportsDataServiceModelValues.reportsTopMenuItems) {
                if (data.value == ReportsTopMenuItemsValues.print) {
                    this.getReportsData(0,0,false,data.value);
                }
                else if (data.value == ReportsTopMenuItemsValues.PDF) {
                    this.getReportsData(0,0,false,data.value);
                }
                else if (data.value == ReportsTopMenuItemsValues.XLS) {
                    this.getReportsData(0,0,false,data.value);
                }
                else if (data.value == ReportsTopMenuItemsValues.XLSX) {
                    this.getReportsData(0,0,false,data.value);
                }
                else if (data.value == ReportsTopMenuItemsValues.Refresh) {
                    this.loadListingWithFilters();
                }else if (data.value == ReportsTopMenuItemsValues.ReflowTable) {
                    this.reflowTable = !this.reflowTable;
                }
            }
        });
    }

    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }

    ngOnChanges(changes: SimpleChanges){
        if(changes?.displayFilterPopup){
            this.displayFilterPopup = changes.displayFilterPopup?.currentValue||false;
            this.setTempFilterValues();
        }

        if(changes?.reloadContent && changes?.reloadContent?.currentValue){
            this.reloadContent = true;
            this.loadListingWithFilters();
        }
    }

    async ngOnInit() {
        this.accountsChannels = await this.dataService.getAccountChannelList();
        this.leadsChannelList = await this.dataService.getLeadChannelList();
        this.initSearch();
        this.initReports();
    }

    getAllTerritoryList() {
        this.selectedTerritory = null;
        const territoryFilterEnabled: any[] = [this.reportsVisitsNames.getterritorywiseaccountvisithistoryofrep, this.reportsVisitsNames.getterritorywiseleadvisithistoryofrep];
        if(territoryFilterEnabled.includes(this.selectedWindow)){
            this.appMainService.isShowSpinner('getAllTerritories');
            this.routeManagementService.getAllTerritoryies(this.selectedChannel?.id, true, true).subscribe({
              next: (response) => {
                const territoryTableData = this.addTerritoryLabel(response || []);
                this.territoryNamesList = JSON.parse(JSON.stringify(territoryTableData)) || [];
                this.appMainService.isHideSpinner('getAllTerritories');
              },
              error: (error) => {
                this.appMainService.isHideSpinner('getAllTerritories');
              }
            })
        }
    }

    addTerritoryLabel(originalData: any[], parentKey: string = 'key') {
        const convertedData = originalData.map((item, index) => {
          const { children, ...data } = item;

          // Generate the unique key for the current node
          const currentKey = `${parentKey}-${index}`;

          // Recursively process children and pass the current node's key as the parent key
          const childrenData = children ? this.addTerritoryLabel(children, currentKey) : [];

          return {
            ...data,
            key: currentKey,
            label: `${data.name}${data?.objectId ? ' (' + data?.count + ')' : ''}`,
            count: data?.count || null,
            selectable: !!data?.objectId,
            children: childrenData.filter(
              (territory) => territory.objectId == this.selectedModuleId
            ),
          };
        });

        return convertedData;
    }

    changeTerritory($event){
        setTimeout(() => {
            this.loadListingWithFilters();
        }, 100);
    }

    resetData(){
        this.selectedChartType = this.chartFilters[0];
        this.currentSummaryResults = [];
        this.gridState = {};
        this.selectedGroupBy = null;
        this.selectedGroupByValue = null;
        this.selectedReportData = null;
        this.filterInColumns = [];
        this.filteredColumns = [];
        this.reportResults = [];
        this.saveFilterData = null;
        this.first = 0;
        this.pageNumber = 1;
        this.pageSize = 15;
        this.totalRecords = 0;
    }

    initReports(){
        if(this.dashboardView && this.selectedWindow){
            let activityType: string = "";

            switch(this.selectedWindow) {
                case ReportsVisitsNames.avareagefieldvisitbyrep:
                    activityType = ReportsVisitsRoutes.avareagefieldvisitbyrep;
                    break;
                case ReportsVisitsNames.getaccountfieldvisithistorybyrep:
                    activityType = ReportsVisitsRoutes.getaccountfieldvisithistorybyrep;
                    break;
                case ReportsVisitsNames.getleadfieldvisithistorybyrep:
                    activityType = ReportsVisitsRoutes.getleadfieldvisithistorybyrep;
                    break;
                case ReportsVisitsNames.getterritorywiseaccountvisithistoryofrep:
                    activityType = ReportsVisitsRoutes.getterritorywiseaccountvisithistoryofrep;
                    break;
                case ReportsVisitsNames.getterritorywiseleadvisithistoryofrep:
                    activityType = ReportsVisitsRoutes.getterritorywiseleadvisithistoryofrep;
                    break;
                case ReportsVisitsNames.getterritorywiseaccountvisithistory:
                    activityType = ReportsVisitsRoutes.getterritorywiseaccountvisithistory;
                    break;
                case ReportsVisitsNames.getterritorywiseleadvisithistory:
                    activityType = ReportsVisitsRoutes.getterritorywiseleadvisithistory;
                    break;
                default:
                    break;
            }
            this.setReports(activityType);
        }else{
            this.router.paramMap.pipe(takeUntil(this.ngUnsubscribe$)).subscribe((param: any) => {
                const activityType = param.params.type;
                this.setReports(activityType);
            });
        }
    }

    setReports(activityType: string){
        this.resetData();
        this.accountsChannelList = ParseHelper.DeepCopy(this.accountsChannels);
        this.hideChart = false;
        this.hideChannelFilter = false;
        this.visitDetailsCols = [
            { id: 1, name: "Rep Name", columnName: "repname", fieldDataType: 'string', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
            { id: 2, name: "Visit Date", columnName: "datetime", fieldDataType: 'date', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
            { id: 3, name: "Check In Time", columnName: "checkintime", fieldDataType: 'time', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
            { id: 4, name: "Check Out Time", columnName: "checkouttime", fieldDataType: 'time', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
            { id: 5, name: "Check In Distance", columnName: "checkinDistance", fieldDataType: 'string', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
            { id: 6, name: "Check Out Distance", columnName: "checkoutDistance", fieldDataType: 'string', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
            { id: 7, name: "Check Out Process", columnName: "checkoutProcess", fieldDataType: 'string', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
            { id: 8, name: "Device Info", columnName: "deviceinfo", fieldDataType: 'string', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
            { id: 9, name: "Time Spent", columnName: "timespent", fieldDataType: 'timespan', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null }
        ];

        switch (activityType) {
            case ReportsVisitsRoutes.avareagefieldvisitbyrep:
                this.selectedModuleId = 0;
                this.selectedModuleName = '';
                this.selectedWindow = ReportsVisitsNames.avareagefieldvisitbyrep;
                this.reportName = ReportsVisitsLabelName.avareagefieldvisitbyrep;
                this.hideChart = true;
                this.hideChannelFilter = true;
                this.visitDetailsCols = [
                    { id: 1, name: "Store Name", columnName: "businessnameGroup", fieldDataType: 'string', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
                    { id: 1, name: "Channel", columnName: "storeChannelName", fieldDataType: 'string', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
                    { id: 1, name: "Module", columnName: "storeModuleName", fieldDataType: 'string', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
                    { id: 2, name: "Visit Date", columnName: "datetime", fieldDataType: 'date', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
                    { id: 3, name: "Check In Time", columnName: "checkintime", fieldDataType: 'time', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
                    { id: 4, name: "Check Out Time", columnName: "checkouttime", fieldDataType: 'time', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
                    { id: 5, name: "Check In Distance", columnName: "checkinDistance", fieldDataType: 'string', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
                    { id: 6, name: "Check Out Distance", columnName: "checkoutDistance", fieldDataType: 'string', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
                    { id: 7, name: "Check Out Process", columnName: "checkoutProcess", fieldDataType: 'string', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
                    { id: 8, name: "Device Info", columnName: "deviceinfo", fieldDataType: 'string', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
                    { id: 9, name: "Time Spent", columnName: "timespent", fieldDataType: 'timespan', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null }
                ];
                break;

            case ReportsVisitsRoutes.getaccountfieldvisithistorybyrep:
                this.selectedModuleId = AccountModuleId;
                this.selectedModuleName = 'Account';
                this.selectedWindow = ReportsVisitsNames.getaccountfieldvisithistorybyrep;
                this.reportName = ReportsVisitsLabelName.getaccountfieldvisithistorybyrep;
                this.visitDetailsCols = [
                    { id: 1, name: "Rep Name", columnName: "repname", fieldDataType: 'string', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
                    { id: 2, name: "Visit Date", columnName: "datetime", fieldDataType: 'date', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
                    { id: 3, name: "Check In Time", columnName: "checkintime", fieldDataType: 'time', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
                    { id: 4, name: "Check Out Time", columnName: "checkouttime", fieldDataType: 'time', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
                    { id: 5, name: "Check In Distance", columnName: "checkinDistance", fieldDataType: 'string', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
                    { id: 6, name: "Check Out Distance", columnName: "checkoutDistance", fieldDataType: 'string', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
                    { id: 7, name: "Check Out Process", columnName: "checkoutProcess", fieldDataType: 'string', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
                    { id: 8, name: "Device Info", columnName: "deviceinfo", fieldDataType: 'string', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
                    { id: 9, name: "Time Spent", columnName: "timespent", fieldDataType: 'timespan', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null }
                ];
                break;
            case ReportsVisitsRoutes.getleadfieldvisithistorybyrep:
                this.accountsChannelList = ParseHelper.DeepCopy(this.leadsChannelList);
                this.selectedModuleId = LeadModuleId;
                this.selectedModuleName = 'Lead';
                this.selectedWindow = ReportsVisitsNames.getleadfieldvisithistorybyrep;
                this.reportName = ReportsVisitsLabelName.getleadfieldvisithistorybyrep;
                this.visitDetailsCols = [
                    { id: 1, name: "Rep Name", columnName: "repname", fieldDataType: 'string', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
                    { id: 2, name: "Visit Date", columnName: "datetime", fieldDataType: 'date', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
                    { id: 3, name: "Check In Time", columnName: "checkintime", fieldDataType: 'time', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
                    { id: 4, name: "Check Out Time", columnName: "checkouttime", fieldDataType: 'time', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
                    { id: 5, name: "Check In Distance", columnName: "checkinDistance", fieldDataType: 'string', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
                    { id: 6, name: "Check Out Distance", columnName: "checkoutDistance", fieldDataType: 'string', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
                    { id: 7, name: "Check Out Process", columnName: "checkoutProcess", fieldDataType: 'string', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
                    { id: 8, name: "Device Info", columnName: "deviceinfo", fieldDataType: 'string', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
                    { id: 9, name: "Time Spent", columnName: "timespent", fieldDataType: 'timespan', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null }
                ];
                break;

            case ReportsVisitsRoutes.getterritorywiseaccountvisithistoryofrep:
                this.selectedModuleId = AccountModuleId;
                this.selectedModuleName = 'Account';
                this.selectedWindow = ReportsVisitsNames.getterritorywiseaccountvisithistoryofrep;
                this.reportName = ReportsVisitsLabelName.getterritorywiseaccountvisithistoryofrep;
                this.visitDetailsCols = [
                    { id: 1, name: "Rep Name", columnName: "repname", fieldDataType: 'string', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
                    { id: 2, name: "Visit Date", columnName: "datetime", fieldDataType: 'date', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
                    { id: 3, name: "Check In Time", columnName: "checkintime", fieldDataType: 'time', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
                    { id: 4, name: "Check Out Time", columnName: "checkouttime", fieldDataType: 'time', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
                    { id: 5, name: "Check In Distance", columnName: "checkinDistance", fieldDataType: 'string', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
                    { id: 6, name: "Check Out Distance", columnName: "checkoutDistance", fieldDataType: 'string', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
                    { id: 7, name: "Check Out Process", columnName: "checkoutProcess", fieldDataType: 'string', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
                    { id: 8, name: "Device Info", columnName: "deviceinfo", fieldDataType: 'string', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
                    { id: 9, name: "Time Spent", columnName: "timespent", fieldDataType: 'timespan', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null }
                ];
                break;
            case ReportsVisitsRoutes.getterritorywiseleadvisithistoryofrep:
                this.accountsChannelList = this.leadsChannelList;
                this.selectedModuleId = LeadModuleId;
                this.selectedModuleName = 'Lead';
                this.selectedWindow = ReportsVisitsNames.getterritorywiseleadvisithistoryofrep;
                this.reportName = ReportsVisitsLabelName.getterritorywiseleadvisithistoryofrep;
                this.visitDetailsCols = [
                    { id: 1, name: "Rep Name", columnName: "repname", fieldDataType: 'string', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
                    { id: 2, name: "Visit Date", columnName: "datetime", fieldDataType: 'date', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
                    { id: 3, name: "Check In Time", columnName: "checkintime", fieldDataType: 'time', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
                    { id: 4, name: "Check Out Time", columnName: "checkouttime", fieldDataType: 'time', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
                    { id: 5, name: "Check In Distance", columnName: "checkinDistance", fieldDataType: 'string', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
                    { id: 6, name: "Check Out Distance", columnName: "checkoutDistance", fieldDataType: 'string', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
                    { id: 7, name: "Check Out Process", columnName: "checkoutProcess", fieldDataType: 'string', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
                    { id: 8, name: "Device Info", columnName: "deviceinfo", fieldDataType: 'string', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null },
                    { id: 9, name: "Time Spent", columnName: "timespent", fieldDataType: 'timespan', dragable: false, enabled: true, isRequired: false, displayOrder: 0, childFields: null }
                ];
                break;

            case ReportsVisitsRoutes.getterritorywiseaccountvisithistory:
                this.selectedModuleId = AccountModuleId;
                this.selectedModuleName = 'Account';
                this.selectedWindow = ReportsVisitsNames.getterritorywiseaccountvisithistory;
                this.reportName = ReportsVisitsLabelName.getterritorywiseaccountvisithistory;
                this.hideChart = true;
                break;
            case ReportsVisitsRoutes.getterritorywiseleadvisithistory:
                this.accountsChannelList = this.leadsChannelList;
                this.selectedModuleId = LeadModuleId;
                this.selectedModuleName = 'Lead';
                this.selectedWindow = ReportsVisitsNames.getterritorywiseleadvisithistory;
                this.reportName = ReportsVisitsLabelName.getterritorywiseleadvisithistory;
                this.hideChart = true;
                break;
            default:
                break;
        }
        this.selectedChannel = this.accountsChannelList ? this.accountsChannelList.find(el=>el.isDefault==true)||this.accountsChannelList[0] : null;
        this.selectedDateFilter = this.filterDataByTime[0];
        this.setSelectedFilters();
        this.getAllTerritoryList();
        this.changeRange();
        this.getColumnSettings();
        this.setFVHByRepData([]);
        //Send To Parent Component For Left Menu Expand
        this.dataService.sendData<IReportsDataServiceLeftMenuExpantionModel>({ actionType: ReportsDataServiceModelValues.reportsLeftMenuExpansion, value: this.selectedWindow });
    }


    setSelectedFilters(){
        const channelId = this.selectedReportFilters?.accountChannelId||this.selectedReportFilters?.leadChannelId
        if(this.selectedReportFilters?.dateFilter){
            this.selectedDateFilter = this.filterDataByTime.find(f=>f.code==this.selectedReportFilters?.dateFilter)||this.filterDataByTime[0];
            this.dateFrom = this.selectedReportFilters?.fromDate ? new Date(this.selectedReportFilters?.fromDate) : this.dateFrom;
            this.dateTo = this.selectedReportFilters?.toDate ? new Date(this.selectedReportFilters?.toDate) : this.dateTo;
        }

        if(channelId){
            this.selectedChannel = this.accountsChannelList ? this.accountsChannelList.find(el=>el.id==channelId)||this.accountsChannelList[0] : null;
        }
    }

    initSearch() {
        this.searchControl.valueChanges.pipe(
            debounceTime(700),
            distinctUntilChanged())
            .subscribe((value: string) => {
                this.searchValue = value.trim() || '';
                this.loadListingWithFilters();
            });
    }

    loadListingWithFilters(): void {
        this.first = 0;
        this.pageNumber = 1;
        this.getReportsSummaryData();
        this.getReportsData(this.pageNumber,this.pageSize,true);
    }

    async getAllAccountsWithPagination(event?: LazyLoadEvent): Promise<void> {
        if (event) {
            this.pageSize = event.rows;
            this.pageNumber = (event.first / event.rows) + 1;

            if (event.sortField) {
                const temp = {
                    field: event.sortField,
                    order: event.sortOrder
                };

                this.gridState['sort'] = temp;
            }
        }
        else {
            this.pageNumber = 1;
            this.pageSize = 15;
        }


        if (this.savedListCols?.length>0) {
            this.getReportsData(this.pageNumber,this.pageSize);
        }
    }

    private formatDate(date: Date): any {
        return moment(date).format('MM-DD-YYYY');
    }

    getRequestModel(currentPageNumber: number = 1, currentPageSize: number = 15, resetSorting: boolean = false, exportType: string = ""){
        let pageNumber = currentPageNumber ? currentPageNumber : 1;

        if(!exportType){
            this.pageNumber = pageNumber;
            this.pageSize = currentPageSize;
        }

        const options: any = {};
        if (this.gridState && this.gridState['sort']) {
            options.sort = {
                SortBy: resetSorting ? null : this.gridState['sort'].field,
                IsAscending: this.gridState['sort'].order === 1 ? true : false
            }
        }

        options.isActive = true;
        options.moduleSearchValue = this.searchValue.trim() || '';
        this.sortByColumnName = options?.sort?.SortBy || null;
        this.isSortByDescending = !options?.sort?.IsAscending;

        const selectableColumns: any[] = [];
        this.selectedColumn = [];

        if (this.savedListCols.length > 0) {
            this.savedListCols.forEach((obj) => {
                if (obj.enabled) {
                    selectableColumns.push(
                        {
                            columnName: obj.columnName,
                            isCustom: obj.isCustom
                        }
                    )
                }
            });
            this.selectedColumn = selectableColumns;
        }

        const sortByColumn = this.savedListCols.find(fld=> fld.columnName==options?.sort?.SortBy);
        const defaultSortColumn = null;
        const sortByColumnDataType = null;

        if(defaultSortColumn){
            selectableColumns.push({
                columnName: 'accountIdForSorting',
                isCustom: false
            })
        }

        const mainCustomerField = this.savedListCols.find(fld=> fld.columnName=='mainCustomer');
        if(mainCustomerField){
            selectableColumns.push({
                columnName: 'parentAccountSequenceNumber',
                isCustom: false
            })
        }

        const requestModel: GelAllDataRequestModel = {
            reportType: this.selectedWindow,
            fromDate: this.dateFrom ? this.formatDate(this.dateFrom) : null,
            toDate: this.dateTo ? this.formatDate(this.dateTo) : null,
            moduleType: this.selectedModuleId,
            channelId: this.selectedChannel?.id,
            territoryIds: this.selectedTerritory?.length > 0
            ? Array.from(new Set(this.selectedTerritory.map(t => t.id)))
            : [],
            isActive: true,
            globalSearchValue: this.searchValue.trim() || '',
            selectableColumns: selectableColumns,
            filter: null,
            pageSize: currentPageSize,
            pageNumber: currentPageNumber,
            sortByColumn: options?.sort?.SortBy || defaultSortColumn,
            sortByColumnDataType: sortByColumn?.fieldDataType||sortByColumnDataType,
            isSortByDescending: !options?.sort?.IsAscending,
            filterInColumns: this.filterInColumns,
            includeChildAccounts: true
        }

        if (this.filterInColumns && this.filterInColumns.length > 0 && requestModel) {
            this.filterInColumns.forEach((obj) => {
                let notInSelectableColumn = requestModel?.selectableColumns.find((item)=>{
                    return item?.columnName == obj?.name;
                });
                let customFieldNotinSelectableColumn = this.savedListCols.find((item)=>{
                    return item?.columnName == obj?.name;
                });
                if(!notInSelectableColumn && customFieldNotinSelectableColumn){
                    requestModel?.selectableColumns.push(
                        {
                            columnName: customFieldNotinSelectableColumn?.columnName,
                            isCustom: customFieldNotinSelectableColumn?.isCustom || false
                        }
                    );
                }
            });
        }

        const groupRequest: GetAllDataGroupByRequest = {
            ...requestModel,
            includeChildAccounts: true,
            groupByColumnName: this.selectedGroupByValue?.groupByColumnName,
            isGroupByColumnCSV: this.selectedGroupByValue?.isGroupByColumnCSV,
            pageSize: 15,
            pageNumber: 1,
            rootPageSize: currentPageSize,
            rootPageNumber: currentPageNumber,
            rootSortByColumnName: this.selectedGroupByValue?.groupByColumnName,
            isRootSortByDescending: (this.selectedGroupByValue?.fieldDataType=="DateTime") as boolean,
            timezone: (this.selectedGroupByValue?.isDateWithTime) ? this.timeZoneService.getUserTimezoneName() : null
        }
        const checkGroupColumn = groupRequest?.selectableColumns.find(field => field.columnName == this.selectedGroupByValue?.groupByColumnName);
        if (this.selectedGroupByValue && !checkGroupColumn) {
            groupRequest?.selectableColumns.push({
                columnName: this.selectedGroupByValue?.groupByColumnName,
                isCustom: this.selectedGroupByValue?.isCustom
            })
        }

        return {
            groupRequest: groupRequest,
            requestModel: requestModel
        }
    }

    getReportsData(currentPageNumber: number = 1, currentPageSize: number = 15, resetSorting: boolean = false, exportType: string = ""){
        if(this.dashboardView=='charts') return;

        const { groupRequest, requestModel } = this.getRequestModel(currentPageNumber,currentPageSize,resetSorting,exportType);

        const apiCall = this.selectedGroupByValue ? this.visitReportsService.getVisitByRepGroupList(groupRequest) : this.visitReportsService.getVisitByRepReports(requestModel);

        this.appMainService.isShowSpinner('getReportsData');
        apiCall.pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (response) => {
                    this.appMainService.isHideSpinner('getReportsData');
                    if (response) {
                        const reportResults = this.selectedGroupByValue ? response.groupedList || [] : response?.list || [];

                        if(exportType){
                            this.formatData(reportResults);
                            this.exportData(exportType);
                        }else{
                            this.reportResults = this.formatData(reportResults);
                        }

                        this.totalRecords = response?.totalNumberOfRows;
                        this.noDataFoundOrLoadingText = this.reportResults.length ? '' : 'No data found.';
                        this.showFloatHeader = this.dashboardView ? false : true;
                        this.reflowTable = !this.reflowTable;
                    }
                    this.onReloadContent.emit(false);
                },
                error: (error) => {
                    this.onReloadContent.emit(false);
                    this.showFloatHeader = this.dashboardView ? false : true;
                    this.reflowTable = !this.reflowTable;
                    this.noDataFoundOrLoadingText = 'No data found.';
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error!',
                        detail: 'Error occurring when loading accounts. Please try after sometime.'
                    });
                    this.appMainService.isHideSpinner('getReportsData');
                },
                complete: () => {

                }
            })
    }

    formatData(reportResults: any[],listPage: boolean = false){
        this.exportResults = [];
        if(this.selectedGroupByValue && !listPage){
            reportResults.map((rowData, index)=>{
                rowData.list?.map((childData,j)=>{
                    childData.visit_accountid = rowData?.visit_accountid||childData.id;
                    childData.id = `${index+1}${j+1}`;
                    this.exportResults.push(childData);
                });
            });
        }else{
            reportResults.map((rowData, index)=>{
                rowData.visit_accountid = rowData?.visit_accountid||rowData.id;
                rowData.id = index+1;
            });
            this.exportResults = reportResults;
        }

        return reportResults;
    }

    exportData(exportType: string){
        if (exportType == ReportsTopMenuItemsValues.print) {
            this.print();
        }
        else if (exportType == ReportsTopMenuItemsValues.PDF) {
            this.exportPDF(this.selectedWindow, false);
        }
        else if (exportType == ReportsTopMenuItemsValues.XLS) {
            this.exportXLS(this.selectedWindow);
        }
        else if (exportType == ReportsTopMenuItemsValues.XLSX) {
            this.exportXLSX(this.selectedWindow);
        }
    }

    getReportsSummaryData(currentPageNumber: number = 1, currentPageSize: number = 15, resetSorting: boolean = false){

        const { groupRequest, requestModel } = this.getRequestModel(currentPageNumber,currentPageSize,resetSorting);
        this.setFVHByRepData([]);
        this.appMainService.isShowSpinner('getReportsSummaryData');
        this.visitReportsService.getVisitByRepReportSummary(requestModel).pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (response) => {
                    this.appMainService.isHideSpinner('getReportsSummaryData');
                    this.onReloadContent.emit(false);
                    if (response) {
                        this.currentSummaryResults = response||[];
                        this.setFVHByRepData(response||[])
                    }
                },
                error: (error) => {
                    this.noDataFoundOrLoadingText = 'No data found.';
                    this.onReloadContent.emit(false);
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error!',
                        detail: 'Error occurring when loading data. Please try after sometime.'
                    });
                    this.appMainService.isHideSpinner('getReportsSummaryData');
                },
                complete: () => {

                }
            })
    }

    onListPageChange($event,rowData: any){
        const options: any = {};
        if (this.gridState && this.gridState.sort) {
            options.sort = {
                SortBy: this.gridState['sort'].field,  //this.fieldAndSearchFieldMap[this.gridState.sort.field],
                IsAscending: this.gridState.sort.order === 1 ? true : false
            }
        }

        const requestModel: GelAllDataRequestModel = {
            reportType: this.selectedWindow,
            fromDate: this.dateFrom ? this.formatDate(this.dateFrom) : null,
            toDate: this.dateTo ? this.formatDate(this.dateTo) : null,
            moduleType: this.selectedModuleId,
            channelId: this.selectedChannel?.id,
            territoryIds: this.selectedTerritory?.length > 0
            ? Array.from(new Set(this.selectedTerritory.map(t => t.id)))
            : [],
            isActive: true,
            globalSearchValue: this.searchValue.trim() || '',
            selectableColumns: this.selectedColumn,
            filter: null,
            pageSize: 15,
            pageNumber: ($event?.page+1),
            sortByColumn: options?.sort?.SortBy || null,
            isSortByDescending: this.isSortByDescending,
            filterInColumns: ParseHelper.DeepCopy(this.filterInColumns||[]),
            includeChildAccounts: true
        }

        let groupValue = rowData.groupByValue===null ? [""] : [rowData.groupByValue];
        let operator = "IsEqualTo";
        if(!rowData.groupByValue){
            operator = "NoValue";
        }else if(this.selectedGroupByValue?.fieldDataType=="DateTime"){
            operator = "Between";
            groupValue = [];
            let dateRangeFrom = new Date(rowData.groupByValue);
            let dateRangeTo = new Date(rowData.groupByValue);

            dateRangeFrom = this.timeZoneService._getUTCDateTimeWithZone(dateRangeFrom, (this.selectedGroupByValue?.isDateWithTime||false), true, false);
            dateRangeTo = this.timeZoneService._getUTCDateTimeWithZone(dateRangeTo, (this.selectedGroupByValue?.isDateWithTime||false), true, false);
            dateRangeTo.setDate(dateRangeTo.getDate() + 1);
            dateRangeTo = new Date(dateRangeTo.getTime() - 1000);
            groupValue.push(this.timeZoneService._getUTCDateTimeString(dateRangeFrom),this.timeZoneService._getUTCDateTimeString(dateRangeTo));
        }
        const groupFilterData: ReportFilterInColumn = {
            name: this.selectedGroupByValue?.columnName,
            value: null,
            operator: operator,
            operationType: "AND",
            values: groupValue
        }

        const groupFilterIndex = requestModel.filterInColumns.findIndex(filter=> filter.name==this.selectedGroupByValue?.columnName);

        if(groupFilterIndex>=0){
            requestModel.filterInColumns[groupFilterIndex] = groupFilterData;
        }else{
            requestModel.filterInColumns.push(groupFilterData);
        }

        this.appMainService.isShowSpinner('onListPageChange');
        this.visitReportsService.getVisitByRepReports(requestModel)
        .pipe(takeUntil(this.ngUnsubscribe$))
        .subscribe({
            next: (response) => {
                if (response) {
                    rowData.list = this.formatData(response.list,true);
                }
                this.appMainService.isHideSpinner('onListPageChange');
            },
            error: (error) => {
                this.appMainService.isHideSpinner('onListPageChange');
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error!',
                    detail: 'Error occurring when loading leads. Please try after sometime.'
                });
            },
            complete: () => {

            }
        });
    }

    onRowSelect(){
        this.getVisitDetails();
    }

    getVisitDetails(){
        let objectRefId: number = this.selectedReportData?.visit_accountid;
        const request: VisitDetailsRequest = {
            userId: this.selectedReportData?.visit_userid||0,
            objectRefId: objectRefId,
            objectId: this.selectedModuleId,
            fromDate: this.dateFrom ? this.formatDate(this.dateFrom) : null,
            toDate: this.dateTo ? this.formatDate(this.dateTo) : null
        }
        this.appMainService.isShowSpinner('getVisitDetails');
        this.visitReportsService.getVisitDetails(request).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
            next: (response)=>{
                this.appMainService.isHideSpinner('getVisitDetails');
                this.visitDetailsData = response||[];
                this.formatVisitDetails();
                this.displayVisitDetails = true;
            },
            error: (error)=>{
                this.appMainService.isHideSpinner('getVisitDetails');
            }
        })
    }

    formatVisitDetails(){
        this.visitDetailsData?.map(visitDetails=>{
            visitDetails.repname = visitDetails?.visit_username||this.selectedReportData?.visit_username;
            const storeLat = parseFloat(visitDetails['latitude']);
            const storeLng = parseFloat(visitDetails['longitude']);

            const checkinLat =  parseFloat(visitDetails['starttimelatitude']);
            const checkinLlng =  parseFloat(visitDetails['starttimelongitude']);

            const checkOutLat =  parseFloat(visitDetails['endtimelatitude']);
            const checkOutLlng =  parseFloat(visitDetails['endtimelongitude']);

            if(storeLat && storeLng && checkinLat && checkinLlng){
                const distance = latlngDistance(storeLat,storeLng,checkinLat,checkinLlng);
                visitDetails['checkinDistance'] = `${distance} Miles`;
            }else{
                visitDetails['checkinDistance'] = "Address Missing";
            }

            if(storeLat && storeLng && checkOutLat && checkOutLlng){
                const distance = latlngDistance(storeLat,storeLng,checkOutLat,checkOutLlng);
                visitDetails['checkoutDistance'] = `${distance} Miles`;
            }else{
                visitDetails['checkoutDistance'] = "Address Missing";
            }

            visitDetails['checkoutProcess'] = visitDetails?.autocheckedout ? 'Auto' : 'Mannually';
        });

        const r: any[] = [this.reportsVisitsNames.getterritorywiseaccountvisithistoryofrep, this.reportsVisitsNames.getterritorywiseleadvisithistoryofrep,
            this.reportsVisitsNames.getterritorywiseaccountvisithistory, this.reportsVisitsNames.getterritorywiseleadvisithistory
        ];

        const r2: any[] = [this.reportsVisitsNames.avareagefieldvisitbyrep];

        if(r.includes(this.selectedWindow)){
            const visitUserGroup = this.visitDetailsData.reduce((acc, curr) => {
                const { username } = curr;
                if (!acc[username]) {
                    acc[username] = [];
                }

                acc[username].push(curr);
                return acc;
            }, {});

            let visitList: any[] = [];
            Object.keys(visitUserGroup).map(username=>{
                visitList.push({
                    repname: username,
                    rowColor: 'child-color2 p-text-bold'
                });
                visitUserGroup[username] = visitUserGroup[username].sort((a, b)=> new Date(b.datetime).getTime() - new Date(a.datetime).getTime());
                let currentColor = 'child-color2';
                visitUserGroup[username].map((visitDetails, index)=>{
                    const currentDate = this.localDatePipe.transform(visitDetails['datetime'], 'MM/DD/YYYY');
                    const lastDate = this.visitDetailsData?.[(index-1)] ? this.localDatePipe.transform(this.visitDetailsData[(index-1)]['datetime'], 'MM/DD/YYYY') : null;
                    let diff = !!(currentDate == lastDate);

                    if(diff){
                        visitDetails.rowColor = this.visitDetailsData[index-1].rowColor;
                    }else{
                        visitDetails.rowColor = currentColor=='child-color1' ? 'child-color2' : 'child-color1';
                    }

                    currentColor = visitDetails.rowColor;
                })

                visitList = [...visitList,...visitUserGroup[username]];
            });
            this.visitDetailsData = visitList;
        }else if(r2.includes(this.selectedWindow)){
            const visitUserGroup = this.visitDetailsData.reduce((acc, curr) => {
                const { businessname } = curr;
                if (!acc[businessname]) {
                    acc[businessname] = [];
                }

                acc[businessname].push(curr);
                return acc;
            }, {});

            let visitList: any[] = [];
            Object.keys(visitUserGroup).map(businessname=>{
                const storeDetails = visitUserGroup[businessname][0];
                visitList.push({
                    businessnameGroup: businessname,
                    storeChannelName: storeDetails.channelname,
                    storeModuleName: storeDetails.modulename,
                    rowColor: 'child-color2 p-text-bold'
                });
                visitUserGroup[businessname] = visitUserGroup[businessname].sort((a, b)=> new Date(b.datetime).getTime() - new Date(a.datetime).getTime());
                let currentColor = 'child-color2';
                visitUserGroup[businessname].map((visitDetails, index)=>{
                    const currentDate = this.localDatePipe.transform(visitDetails['datetime'], 'MM/DD/YYYY');
                    const lastDate = this.visitDetailsData?.[(index-1)] ? this.localDatePipe.transform(this.visitDetailsData[(index-1)]['datetime'], 'MM/DD/YYYY') : null;
                    let diff = !!(currentDate == lastDate);

                    if(diff){
                        visitDetails.rowColor = this.visitDetailsData[index-1].rowColor;
                    }else{
                        visitDetails.rowColor = currentColor=='child-color1' ? 'child-color2' : 'child-color1';
                    }

                    currentColor = visitDetails.rowColor;
                })

                visitList = [...visitList,...visitUserGroup[businessname]];
            });
            this.visitDetailsData = visitList;
        }else{
            let currentColor = 'child-color2';
            this.visitDetailsData.map((visitDetails, index)=>{
                const currentDate = this.localDatePipe.transform(visitDetails['datetime'], 'MM/DD/YYYY');
                const lastDate = this.visitDetailsData?.[(index-1)] ? this.localDatePipe.transform(this.visitDetailsData[(index-1)]['datetime'], 'MM/DD/YYYY') : null;
                let diff = !!(currentDate == lastDate);

                if(diff){
                    visitDetails.rowColor = this.visitDetailsData[index-1].rowColor;
                }else{
                    visitDetails.rowColor = currentColor=='child-color1' ? 'child-color2' : 'child-color1';
                }

                currentColor = visitDetails.rowColor;
            })
        }
    }

    //#region column settings
    openColumnSettings(){
        this.displayColumnSettings = true;
    }

    onChangeChannel(loadOnlyTerritory: boolean = false){
        if(loadOnlyTerritory){
            this.getAllTerritoryList();
        }else{
            this.resetData();
            this.getAllTerritoryList();
            this.getColumnSettings();
        }
    }

    getColumnSettings(restoreFilter: boolean = false, reloadData: boolean = true){
        this.appMainService.isShowSpinner('getColumnSettings');
        this.visitReportsService.getColumnSettings(this.selectedModuleId,this.selectedChannel?.id,this.selectedWindow).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
            next: (response)=>{
                this.appMainService.isHideSpinner('getColumnSettings');
                this.columnSettingsN = response;
                if (response?.listViewSections) {
                    this.savedListCols = getSectionWiseFlatCols(response?.listViewSections);
                    this.filterCols = this.savedListCols.filter(f=> !['visit_territory'].includes(f.columnName));
                    this.filterCols.map(field=>{
                        if(['visit_totalvisit','visit_visitedcount','visit_nonvisitedcount'].includes(field?.columnName)){
                            field.operators = [...field.operators, ...['HasValue','NoValue']];
                        }
                    })
                    this.enabledListCols = this.savedListCols.filter(field=> field.enabled);
                    this.enabledListCols.map(field => {
                        field.groupByColumnName = (field.columnName == 'tags') ? 'tagsCsv' : field.columnName;
                        field.isGroupByColumnCSV = [FormControlList.MultipleDropDownList, FormControlList.CheckBox].includes(field.formControlType);
                    });

                    if(restoreFilter){
                        this.saveFilterData = {groupByFieldId: null, filter: this.filterInColumns};
                    }

                    if(reloadData){
                        this.pageNumber = 1;
                        this.first = 0;
                        this.getReportsData(this.pageNumber,this.pageSize);
                        this.getReportsSummaryData();
                    }
                }
            },
            error: (error)=>{
                this.appMainService.isHideSpinner('getColumnSettings');
            }
        });
    }

    savedColumnSettings(data: { updatedColumnSettings: any, updateColumnSettingsData: any }): void {
        let requestbody = {
            reportType: this.selectedWindow,
            moduleId: this.selectedModuleId,
            channelId: this.selectedChannel?.id,
            listViewFields: data?.updateColumnSettingsData?.listViewFields,
            listViewSections: data?.updateColumnSettingsData?.listViewSections
        }

        this.visitReportsService.updateVisitColumnSettings(requestbody).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
            next: (result)=>{
                this.messageService.add({ severity: 'success', summary: 'Updated', detail: 'Column settings updated successfully.' });
                this.getColumnSettings(true);
                this.displayColumnSettings = false;// close column settings
            },
            error: (error)=>{
                this.messageService.add({ severity: 'error', summary: 'Update Failed', detail: 'Failed to update column settings, please try again.' });
            }
        });
    }

    cancelColumnSettings(): void {
        this.displayColumnSettings = false;
    }
    //#endregion

    //#region group by
    showGroupBy() {
        this.selectedGroupBy = this.selectedGroupByValue || null;
    }

    applyGroup() {
        if (this.selectedGroupBy) {
            this.disabledLabelNames = [...new Set([...this.filteredColumns, this.selectedGroupBy.columnName])];
        }

        this.selectedGroupByValue = this.selectedGroupBy;
        this.reportResults = [];
        this.loadListingWithFilters();
    }

    resetGroup(reloadList: boolean = false) {
        this.disabledLabelNames = this.disabledLabelNames.filter(dln => dln !== (this.selectedGroupByValue?.columnName ?? ''));
        this.disabledLabelNames = [...new Set([...this.disabledLabelNames, ...this.filteredColumns])];

        this.selectedGroupBy = null;
        this.selectedGroupByValue = null;
        if(reloadList){
            this.reportResults = [];
            this.loadListingWithFilters();
        }
    }

    get disabledLabelColumns(){
        let disabledColumns = this.selectedGroupByValue?.columnName ? [this.selectedGroupByValue?.columnName] : [];
        // disabledColumns = this.filteredColumns?.length>0 ? [...new Set([...disabledColumns, ...this.filteredColumns])] : disabledColumns;
        return disabledColumns;
    }

    onAllGroupExpand(){
        this.groupAllExpanded = !this.groupAllExpanded;
        this.reportResults.map(rowData=>{
            rowData['expanded'] = this.groupAllExpanded;
        })
    }

    onGroupExpand(rowData: any){
        rowData['expanded'] = !rowData?.expanded as boolean;
    }

    expandSelectedRowGroup(){
        const groupByValue = this.selectedReportData[this.selectedGroupByValue.columnName];
        this.groupAllExpanded = false;
        this.reportResults.map((rowData: any)=>{
            rowData['expanded'] = (rowData.groupByValue==groupByValue) as boolean;
        })
    }
    //#endregion

    //#region filters

    changeRange(reloadApi: boolean = false): void {

        let today = this.timeZoneService.showDateTimeWithZone(new Date());
        let todayCopy = this.timeZoneService.showDateTimeWithZone(new Date());

        if (this.selectedDateFilter.code == 'today') {
            this.dateFrom = today;
            this.dateTo = today;
        } else if (this.selectedDateFilter.code == 'yesterday') {
            let yesterday = todayCopy;
            yesterday.setDate(todayCopy.getDate() - 1);

            this.dateFrom = yesterday;
            this.dateTo = yesterday;
        } else if (this.selectedDateFilter.code == 'this month') {
            let firstday = todayCopy;
            firstday.setDate(1);

            this.dateFrom = firstday;
            this.dateTo = today;
        } else if (this.selectedDateFilter.code == 'last month') {
            this.dateFrom = new Date(today.getFullYear(), today.getMonth() - 1, 1);
            this.dateTo = new Date(today.getFullYear(), today.getMonth(), 0);
        } else if (this.selectedDateFilter.code == 'last 7 days') {
            let seven = todayCopy;
            seven.setDate(todayCopy.getDate() - 7);

            this.dateFrom = seven;
            this.dateTo = today;
        } else if (this.selectedDateFilter.code == 'last 15 days') {
            let fifteen = todayCopy;
            fifteen.setDate(todayCopy.getDate() - 15);

            this.dateFrom = fifteen;
            this.dateTo = today;
        } else if (this.selectedDateFilter.code == 'last 30 days') {
            let thirty = todayCopy;
            thirty.setDate(todayCopy.getDate() - 30);

            this.dateFrom = thirty;
            this.dateTo = today;
        } else if (this.selectedDateFilter.code == 'last 60 days') {
            let sixty = todayCopy;
            sixty.setDate(todayCopy.getDate() - 60);

            this.dateFrom = sixty;
            this.dateTo = today;
        } else if (this.selectedDateFilter.code == 'last 90 days') {
            let ninety = todayCopy;
            ninety.setDate(todayCopy.getDate() - 90);

            this.dateFrom = ninety;
            this.dateTo = today;
        } else if (this.selectedDateFilter.code == 'custom') {
            if(reloadApi){
                this.customDateRange = true;
            }
            if (this.dateFrom && this.dateTo) {
                this.dateFrom = new Date(this.dateFrom);
                this.dateTo = new Date(this.dateTo);
            } else {
                this.dateFrom = null;
                this.dateTo = null;
            }
            reloadApi = false;
        } else {
            this.dateFrom = null;
            this.dateTo = null;
        }

        if(reloadApi){
            this.loadListingWithFilters();
        }
    }

    applyCustomDateRange(){
        if (this.dateFrom && this.dateTo) {
            this.dateFrom = new Date(this.dateFrom);
            this.dateTo = new Date(this.dateTo);
            this.customDateRange = false;
            this.loadListingWithFilters();
        }
    }

    applyFilters(event: { selectedFilter: ReportFilterInColumn[] }) {
        this.filterInColumns = event?.selectedFilter||null;
        this.filteredColumns = (this.filterInColumns ?? []).map((sf => sf.name)) || [];
        this.loadListingWithFilters();
    }
    //#endregion

    //#region Print, PDF, XLSX

    print() {
        this.appMainService.isShowSpinner('Print');
        this.exportPDF(this.selectedWindow, true);
        this.appMainService.isHideSpinner('Print');
    }

    exportPDF(selectedWindow: string, isPrintFlag = false) {
        this.PDFFieldVisitReport(selectedWindow, isPrintFlag, "NoExcel");
    }

    exportXLS(selectedWindow: string) {
        this.PDFFieldVisitReport(selectedWindow, false, "exportXLSX");
    }

    exportXLSX(selectedWindow: string) {
        this.PDFFieldVisitReport(selectedWindow, false, "exportXLSX");
    }

    PDFFieldVisitReport(selectedWindow: string, isPrintFlag: boolean, isexportXLS: string) {
        this.organizationName = this.app.user.organizationName;

        if (isexportXLS === "exportXLS" || isexportXLS === "exportXLSX") {
            let dataResult = [];
            this.exportResults.map(elem=>{
                const obj = {};
                this.savedListCols.filter(col=> col.enabled).map(col=>{
                    obj[col.name] = this.formatExportData(elem[col.columnName],col);
                });

                dataResult.push(obj);
            });

            if (isexportXLS === "exportXLSX") {
                import("xlsx").then(xlsx => {
                    const worksheet = xlsx.utils.json_to_sheet(dataResult);
                    const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
                    const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
                    const fileName = this.selectedChannel ? `${this.reportName} (${this.selectedChannel?.name})` : this.reportName;
                    this.saveAsExcelFilexlsx(excelBuffer, fileName);
                });
            }

            if (isexportXLS === "exportXLS") {
                import("xlsx").then(xlsx => {
                    const worksheet = xlsx.utils.json_to_sheet(dataResult);
                    const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
                    const excelBuffer: any = xlsx.write(workbook, { bookType: 'xls', type: 'array' });
                    const fileName = this.selectedChannel ? `${this.reportName} (${this.selectedChannel?.name})` : this.reportName;
                    this.saveAsExcelFilexls(excelBuffer, fileName);
                });
            }
        }
        else {
            let pdfResults = [];
            let pdfcolumns = [];
            pdfcolumns = this.savedListCols.filter(col=> col.enabled).map(col=>{ return {dataKey: col.columnName, header: col.name }});
            this.exportResults.map(elem=>{
                const obj = {};
                this.savedListCols.filter(col=> col.enabled).map(col=>{
                    obj[col.columnName] = this.formatExportData(elem[col.columnName],col);
                });

                pdfResults.push(obj);
            })

            const fileName = this.selectedChannel ? `${this.reportName} (${this.selectedChannel?.name})` : this.reportName;
            let options: PrintPdfModel.IPrintPdfOptions = new PrintPdfModel.PrintPdfOptions();
            // let doc = new jsPDF('l', 'mm', [900, 900]);
            let doc = new jsPDF(options.orientation, options.unit, options.format);

            doc.setFontSize(options.organizationName.fontSize);
            doc.text(this.organizationName, options.organizationName.x, options.organizationName.y);

            doc.setFontSize(options.dateFromTo.fontSize);
            let dateFrom = new Date(this.dateFrom);
            let dateTo = new Date(this.dateTo);
            let fdate = ((dateFrom.getMonth() > 8) ? (dateFrom.getMonth() + 1) : ('0' + (dateFrom.getMonth() + 1))) + '/' + ((dateFrom.getDate() > 9) ? dateFrom.getDate() : ('0' + dateFrom.getDate())) + '/' + dateFrom.getFullYear();
            let tdate = ((dateTo.getMonth() > 8) ? (dateTo.getMonth() + 1) : ('0' + (dateTo.getMonth() + 1))) + '/' + ((dateTo.getDate() > 9) ? dateTo.getDate() : ('0' + dateTo.getDate())) + '/' + dateTo.getFullYear();

            !fdate.includes('NaN') && !tdate.includes('NaN') && doc.text(fdate + '  -  ' + tdate, options.dateFromTo.x, options.dateFromTo.y, { align: options.dateFromTo.align });

            doc.setFontSize(options.reportName.fontSize);
            doc.text(fileName, options.reportName.x, options.reportName.y, { align: options.reportName.align });

            let fontSize = 10;

            if(pdfcolumns?.length>10){
                fontSize = 6;
            }else if(pdfcolumns?.length>18){
                fontSize = 4;
            }

            doc.setFontSize(fontSize);
            autoTable(doc, {
                theme: options.autoTable.theme,
                startY: options.autoTable.startY,
                body: pdfResults?.length > 0 ? pdfResults : [], //dataResult,
                columns: pdfResults?.length > 0 ? pdfcolumns : ["No Data Available."],
                showHead: options.autoTable.showHead,
                headStyles: {
                    textColor: '#FFFFFF',
                    fontSize: fontSize
                },
                bodyStyles: {
                    fontSize: fontSize
                },
                styles: {
                    minCellHeight: options.autoTable.styles.minCellHeight,
                    fontSize: fontSize
                },
            })

            if (isPrintFlag) {
                window.open(URL.createObjectURL(doc.output("blob")))
            }
            else {
                this.saveAsPdfFile(doc, fileName);
            }
            this.appMainService.isHideSpinner('FieldVisitReport');
        }
    }
    saveAsExcelFilexls(buffer: any, fileName: string): void {
        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xls';
        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
    }
    saveAsExcelFilexlsx(buffer: any, fileName: string): void {
        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xlsx';
        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
    }

    private saveAsPdfFile(buffer: any, fileName: string): void {
        buffer.save(fileName + '.pdf');
    }

    formatExportData(value: any, field: any){
        if(field.columnName=='tags'){
            value = value?.length>0 ? value.map(tag=> tag.name).join(', '): null;
        }else if(['visit_timespent','visit_t_timespent'].includes(field.columnName)){
            value = this.timeConvertPipe.transform(value);
        }else if(['Percentage','Currency','RichText','EncryptedText'].includes(field?.formControlType)){
            switch(field?.formControlType){
                case 'Percentage':
                    value = (value || value===0) ? this.percentageSymbolPipe.transform(value) : value;
                    break;
                case 'Currency':
                    value = (value || value===0) ? this.currencySymbolPipe.transform(value) : value;
                    break;
                case 'RichText':
                    value = value ? this.removeHtmlTagsPipe.transform(value) : value;
                    break;
                case 'EncryptedText':
                    value = value ? '******' : value;
                    break;
            }
        }else{
            switch(field?.fieldDataType){
                case 'DateTime':
                    value = field?.isDateWithTime ? (field?.isCustom ? this.localDatePipe.transform(value,'dateTime',false) : this.localDatePipe.transform(value,'dateTime')) : this.datePipe.transform(value,'MM/dd/yyyy');
                    break;
                case 'Time':
                    value = this.onlyTimePipe.transform(value);
                    break;
            }
        }

        return value;
    }

    //#endregion

    //#region exports
    openAsPDF(businessName: string, repName: string) {
        let pdfcolumns = this.visitDetailsCols.map(col=>{
            return {dataKey: col.columnName, header: col.name }
        });
        const dataResult = this.visitDetailsData.map(rowData=>{
            const obj = {};
            this.visitDetailsCols.map(col=>{
                obj[col.columnName] = rowData?.[col.columnName]||"";

                switch(col.fieldDataType){
                    case 'date':
                        obj[col.columnName] = this.localDatePipe.transform(rowData[col.columnName],'MM/DD/YYYY');
                        break;
                    case 'time':
                        obj[col.columnName] = this.localDatePipe.transform(rowData[col.columnName],'h:mm a');
                        break;
                    case 'timespan':
                        obj[col.columnName] = (rowData[col.columnName] || rowData[col.columnName]==0) ? this.timeConvertPipe.transform(rowData[col.columnName]) : '';
                        break;
                }
            });

            return obj;
        });

        const pdfOptions = new PrintPdfModel.PrintPdfOptions();

        ReportsPrintPdfService.openOrExportAsPDF(pdfcolumns, dataResult, this.organizationName, this.dateFrom, this.dateTo, `${businessName} ${this.reportName} ${repName}`, null, null, true);
    }

    downloadAsXLS(repName: string = '') {

        const dataResult = this.visitDetailsData.map(rowData=>{
            const obj = {};
            this.visitDetailsCols.map(col=>{
                obj[col.name] = rowData?.[col.columnName]||"";

                switch(col.fieldDataType){
                    case 'date':
                        obj[col.name] = this.localDatePipe.transform(rowData[col.columnName],'MM/DD/YYYY');
                        break;
                    case 'time':
                        obj[col.name] = this.localDatePipe.transform(rowData[col.columnName],'h:mm a');
                        break;
                    case 'timespan':
                        obj[col.name] = (rowData[col.columnName] || rowData[col.columnName]==0) ? this.timeConvertPipe.transform(rowData[col.columnName]) : '';
                        break;
                }
            });

            return obj;
        });

        import("xlsx").then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(dataResult);
            const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
            const excelBuffer: any = xlsx.write(workbook, { bookType: 'xls', type: 'array' });
            this.saveAsExcelFileXLS(excelBuffer, this.reportName);
        });

    }

    saveAsExcelFileXLS(buffer: any, fileName: string): void {
        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xls';
        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
    }
    //#endregion

    //#region charts
    changeChartFilter($event){
        this.selectedChartType = $event;
        this.setFVHByRepData(this.currentSummaryResults);
    }

    setFVHByRepData(results: any[]): void {
        this.setFVHByRepBarData([], [], [],[]);
        if (!results || !results.length) {
            return;
        }

        const labels: string[] = [];
        const totalVisits: number[] = [];
        const geoMatchedVisits: number[] = [];
        const geoNotMatchedVisits: number[] = [];

        results.sort((b,a)=> (a.visit_visitedcount+a.visit_nonvisitedcount) - (b.visit_visitedcount+b.visit_nonvisitedcount)).map(rowData => {
            const allVisitedCount = rowData?.visit_visitedcount||0;
            const allNonVisitedCount = rowData?.visit_nonvisitedcount||0;
            const totalVisit = allVisitedCount + allNonVisitedCount;

            totalVisits.push(totalVisit);
            geoMatchedVisits.push(allVisitedCount);
            geoNotMatchedVisits.push(allNonVisitedCount);

            switch(this.selectedWindow){
                case ReportsVisitsNames.getterritorywiseleadvisithistoryofrep:
                case ReportsVisitsNames.getterritorywiseaccountvisithistoryofrep:
                    labels.push(`${rowData.visit_territory || 'N/A'}`);
                    break;
                default:
                    labels.push(`${rowData.visit_username || 'N/A'}`);
                    break;
            }
        });

        this.setFVHByRepBarData(labels, geoMatchedVisits, geoNotMatchedVisits, totalVisits);
    }

    setFVHByRepBarData(labels: string[], visitedData: number[], nonVisitedData: number[], totalVisits: number[]): void {
        this.barChartData = {
            labels: labels,
            datasets: [
              { data: totalVisits, label: 'Total Visits' },
              { data: visitedData, label: 'Geo Matched Visits' },
              { data: nonVisitedData, label: 'Geo Not Matched Visits' },
            ],
        };
    }

    setFVHByTerritorryBarData(labels: string[], visitedData: number[], nonVisitedData: number[]): void {
        this.stackedBarByTerri = {
            labels,
            datasets: [
                {
                    type: 'bar',
                    label: 'Geo Matched Visit',
                    backgroundColor: '#66BB6A',
                    data: visitedData
                },
                {
                    type: 'bar',
                    label: 'Geo Not Matched Visit',
                    backgroundColor: '#ecb71c',
                    data: nonVisitedData
                }
            ]
        };
    }
    //#endregion

    //#region filters
    setTempFilterValues() {
        this.tempFiltersValues = {
            dateFilter: this.selectedDateFilter,
            fromDate: this.dateFrom,
            toDate: this.dateTo,
            channel: this.selectedChannel,
            selectedTerritory: this.selectedTerritory,
            territoryNamesList: this.territoryNamesList
        }
    }

    restoreFilterValues() {
        this.selectedDateFilter = this.tempFiltersValues?.dateFilter;
        this.dateFrom = this.tempFiltersValues?.fromDate;
        this.dateTo = this.tempFiltersValues?.toDate;
        this.selectedChannel = this.tempFiltersValues?.channel;
        this.territoryNamesList = this.tempFiltersValues?.territoryNamesList;
        this.selectedTerritory = this.tempFiltersValues?.selectedTerritory;
    }

    applyAllFilters(applyMode: typeReportsAllFiltersApplyModes) {
        let allFiltersValue: ReportsAllFiltersAppyModels = {
            applyMode: applyMode,
            dateFilter: {
                label: this.selectedDateFilter?.label,
                code: this.selectedDateFilter?.code,
                fromDate: this.dateFrom,
                toDate: this.dateTo
            },
            channel: this.selectedChannel,
            selectedTerritoryIds: this.selectedTerritory?.length > 0
            ? Array.from(new Set(this.selectedTerritory.map(t => t.id)))
            : [],
        }
        this.allFiltersChanges(allFiltersValue);
        this.closeFilterPopup();
    }

    allFiltersChanges(filterValues: ReportsAllFiltersAppyModels){
        switch (this.selectedModuleId) {
            case AccountModuleId:
                filterValues.accountChannel =  this.selectedChannel;
                break;
            case LeadModuleId:
                filterValues.leadChannel =  this.selectedChannel;
                break;
            default:
                break;
        }

        if(this.tempFiltersValues.channel?.id != this.selectedChannel?.id){
            this.getColumnSettings();
        }else{
            this.loadListingWithFilters();
        }

        this.onUpdateAllFilters.emit(filterValues)
    }

    cancelFilterPopup() {
        this.restoreFilterValues();
        this.closeFilterPopup();
    }

    closeFilterPopup() {
        this.displayFilterPopup = false;
        this.onCloseFilterPopup.emit(false);
    }
    //#endregion

}
